import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DateRangeViewComponent } from './components/date-range-view/date-range-view.component';
import { LTDatePickerComponent } from './components/lt-datepicker/lt-datepicker.component';
import { LTDateRangeComponent } from './components/lt-daterange/lt-daterange.component';
import { LTDateRangeMonthYearComponent } from './components/lt-daterange-month-year/lt-daterange-month-year.component';
import { LTDateTimePickerComponent } from './components/lt-datetimepicker/lt-datetimepicker.component';
import { LTDateTimePickerV2Component } from './components/lt-datetimepicker-v2/lt-datetimepicker-v2.component';
import { LTMonthYearPickerComponent } from './components/lt-month-year-picker/lt-month-year-picker.component';
@NgModule({
  imports: [
    CommonModule,
    DateRangeViewComponent,
    LTDatePickerComponent,
    LTDateRangeComponent,
    LTDateRangeMonthYearComponent,
    LTDateTimePickerComponent,
    LTDateTimePickerV2Component,
    LTMonthYearPickerComponent,
  ],
  exports: [
    DateRangeViewComponent,
    LTDatePickerComponent,
    LTDateRangeComponent,
    LTDateRangeMonthYearComponent,
    LTDateTimePickerComponent,
    LTDateTimePickerV2Component,
    LTMonthYearPickerComponent,
  ],
})
export class LTTimePickerModule { }